<app-title-bar titleText="i18n.core.navigation.asset-storage"></app-title-bar>

<!-- hidden search bar: to unhide -> remove cssClass and remove file-manager-hide-search class in styles.scss -->
<ejs-filemanager id='overview' [ajaxSettings]='ajaxSettings' [toolbarSettings]="toolbarSettings"
    [contextMenuSettings]="contextMenuSettings" [allowDragAndDrop]="isDragAndDropAllowed" height="90vh"
    (beforeSend)="beforeSend($event)" (beforeImageLoad)="beforeImageLoad($event)"
    (beforeDownload)="beforeDownload($event)" (beforePopupOpen)="beforePopupOpen($event)"
    (toolbarClick)="onToolbarClick($event)" (fileOpen)="onFileOpen($event)" (menuOpen)='menuOpen($event)'
    (menuClick)='menuClick($event)' (toolbarCreate)="onToolbarCreate($event)" (fileSelect)="onFileSelect($event)" (fileLoad)="onFileLoad($event)"
    (success)="onAjaxCallSuccess($event)">
</ejs-filemanager>

<app-asset-storage-single-edit (OnClose)="onEditFormClose()"></app-asset-storage-single-edit>
<app-asset-storage-multi-upload (OnClose)="onEditFormClose()"></app-asset-storage-multi-upload>
<app-asset-storage-filter #assetStorageFilterComponent
    (filterUpdated)="onFilterUpdated($event)"></app-asset-storage-filter>
<app-asset-storage-directory-permission #directoryPermissionsComponent (directoryPermissionsChange) = "onDirectoryPermissionsChanged()"></app-asset-storage-directory-permission>
<app-asset-storage-collections #assetStorageCollectionsComponent
    (collectionsChange)="onCollectionsChange()"></app-asset-storage-collections>
